<template>
    <div class="daum-postcode">
        <div class="row">
            <div class="col-xs-4">
                <input class="form-control" v-bind:value="postcode.data.zonecode" placeholder="우편번호" readonly>
            </div>
            <div class="col-xs-8">
                <button class="btn btn-default" @click.prevent="open()">주소검색</button>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-8">
                <input class="form-control" v-bind:value="postcode.data.roadAddress" readonly>
            </div>
            <div class="col-xs-4">
                <input class="form-control" v-model="postcode.extraAddress">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "daum-postcode",
        props: ['postcode'],
        methods: {
            open() {
                var $this = this;
                new daum.Postcode({
                    oncomplete: function(data) {

                        // 도로명 주소의 노출 규칙에 따라 주소를 조합한다.
                        // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
                        var fullRoadAddr = data.roadAddress; // 도로명 주소 변수
                        var extraRoadAddr = ''; // 도로명 조합형 주소 변수

                        // 법정동명이 있을 경우 추가한다. (법정리는 제외)
                        // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
                        if(data.bname !== '' && /[동|로|가]$/g.test(data.bname)){
                            extraRoadAddr += data.bname;
                        }
                        // 건물명이 있고, 공동주택일 경우 추가한다.
                        if(data.buildingName !== '' && data.apartment === 'Y'){
                            extraRoadAddr += (extraRoadAddr !== '' ? ', ' + data.buildingName : data.buildingName);
                        }
                        // 도로명, 지번 조합형 주소가 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
                        if(extraRoadAddr !== ''){
                            extraRoadAddr = ' (' + extraRoadAddr + ')';
                        }
                        // 도로명, 지번 주소의 유무에 따라 해당 조합형 주소를 추가한다.
                        if(fullRoadAddr !== ''){
                            fullRoadAddr += extraRoadAddr;
                        }

                        $this.postcode.data = data;

                    }
                }).open();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .daum-postcode {
        margin-bottom: 15px;
        .row {
            &:first-child {
                margin-top: 0;
            }
            margin-top: 15px;

            > div {
                &:last-child {
                    padding-right: 15px;
                }
                padding-right: 0;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/DaumPostcode.vue